export default __webpack_public_path__ + "9704781c0eeddded0a857b485055febb.png";